module.exports = __webpack_public_path__ + "static/media/news-tele-pods.c68486e3.jpg";